import { render, staticRenderFns } from "./serach.vue?vue&type=template&id=4c8066f8"
import script from "./serach.vue?vue&type=script&lang=js"
export * from "./serach.vue?vue&type=script&lang=js"
import style0 from "./serach.vue?vue&type=style&index=0&id=4c8066f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports